interface LabelledRole {
    name: string;
    display_name?: string | null;
}

export const roleLabel = (role: LabelledRole): string => role.display_name ?? role.name;

export const compareRolesByLabel = (a: LabelledRole, b: LabelledRole): number =>
    roleLabel(a).localeCompare(roleLabel(b), undefined, { sensitivity: 'base' });
